module.exports = {
  selectLanguage: 'اختر لغتك',
  tags: 'Tags',
  'tags.allTagsLink': 'Browse all tags',
  'tags.intro': 'Here you can find all the tags',
  'tags.blog.intro': 'Here you can find all the blog tags',
  'tags.pages.intro': 'Here you can find all the tags in the pages',
  'tags.nPostsTaggedWith': `{nPosts, number} {nPosts, plural,
      one {post}
      other {posts}
    } tagged with`,
  home: 'الرئيسية',
  about: 'ما هو حظك.كوم',
  artworks: 'Artworks',
  introduction: 'Introduction',
  portfolio: 'Portfolio',
  painting: 'Painting',
  'painting-new': '2019',
  'painting-oldest': 'oldest',
  sculpture: 'Sculpture',
  marble: 'Marble',
  wood: 'Wood',
  bronze: 'Bronze',
  'other-materials': 'Other materials',
  performance: 'Performance',
  performance01: 'Performance 01',
  performance02: 'Performance 02',
  performance03: 'Performance 03',
  performance04: 'Performance 04',
  'new-media': 'New media',
  augmented_reality: 'Augmented reality',
  interactivity: 'Interactivity',
  experimental: 'Experimental',
  blog: 'Blog',
  'blog-message': 'Last News',
  'keep-reading': 'Keep reading →',
  'find-out-more': 'Find out more...',
  followus: 'Follow Us: ',
  'info-sheet': 'Informative sheet',
  'info-sheet-title': 'Title: ',
  'info-sheet-year': 'Year: ',
  'info-sheet-technique': 'Technique: ',
  'info-sheet-dimensions': 'Dimensions: ',
  contact: 'Contacts',
  'contact.infos': 'Contact informations',
  'contact.fill-the-form': 'Fill the form to send a message',
  'contact.name': 'Name',
  'contact.surname': 'Surname',
  'contact.email': 'Email',
  'contact.subject': 'Subject',
  'contact.gender.male': 'Male',
  'contact.gender.female': 'Female',
  'contact.enquiry': 'Type of Enquiry',
  'contact.enquiry.a': 'Need to know more',
  'contact.enquiry.b': 'About art',
  'contact.enquiry.c': 'Want to say hello',
  'contact.message': 'Message',
  'contact.send': 'Send',
  not_found: '404 - Page Not Found',
  404: 'لا نستطيع العثور على الصفحة ....',
  copyright: '{year}, {company} - All rights reserved.',
  'menu-icon-message': 'Choose a section',
  'menu-icon-subtitle': 'Artworks sections',
  'menu-icon-painting': 'Painting',
  'menu-icon-sculpture': 'Sculpture',
  'menu-icon-performance': 'Performance',
  'menu-icon-interactivity': 'Interactivity',
  'home-page-showing-horoscope': 'أبراج يوم {date}.',
  'home-page-showing-different-date': 'يمكنك أيضا الاختيار من التواريخ الآتية: ',
  'signs.aries': 'الحمل',
  'signs.libra': 'الميزان',
  'signs.taurus': 'الثور',
  'signs.scorpio': 'العقرب',
  'signs.gemini': 'الجوزاء',
  'signs.sagittarius': 'القوس',
  'signs.cancer': 'السرطان',
  'signs.capricorn': 'الجدي',
  'signs.leo': 'الأسد',
  'signs.aquarius': 'الدلو',
  'signs.virgo': 'العذراء',
  'signs.pisces': 'الحوت',
  'site.title': 'حظك.كوم',
  'site.title.description': 'حظك اليوم و ما تقوله النجوم يوم {date}',
  'site.title.sign.description': 'حظك اليوم برج {sign} ليوم {date}',
  'site.description':
    'حظك اليوم ،أخبار الفلك ، الهوروسكوب ، الطالع و المزيد. الان يمكنك معرفة ماذا تريد النجوم أن تخبرك !. نحن نبحث في مواقع الفلك العالمية و نحضرها اليك بالعربية كل يوم. ',
  'site.sign.description':
    'حظك اليوم برج {sign} ليوم {date}. قى حظك.كوم (7azzak.com) يمكنك قراءة توقعات حظك اليوم برج {sign} ، أخبار علم الفلك و المزيد. يمكنك الان قراءة الطالع اليومي من مصادر مختلفة و مواقع عالمية.',
  'redirecting.title': 'يتم تحويلك الان',
  'redirecting.message': 'انتظر من فضلك حتى يتم تحويلكم ...',
};
